import { Box } from '@mui/material';
import React, { useId } from 'react';

import { SectionHeading } from '../Screen/SectionHeading';

import { groupListSx, groupRootSx } from './settingsListStyles';

const untitledRootSx = [groupRootSx, { display: 'flex', flexDirection: 'column', gap: 2 }] as const;

export interface SettingsGroupProps {
  title?: string;
  headingLevel?: 'h2' | 'h3';
  description?: React.ReactNode;
  count?: React.ReactNode;
  footer?: React.ReactNode;
  'aria-label'?: string;
  children: React.ReactNode;
}

const GroupList: React.FC<{ labelledBy?: string; label?: string; children: React.ReactNode }> = ({
  labelledBy,
  label,
  children,
}) => (
  <Box component="ul" aria-labelledby={labelledBy} aria-label={labelledBy === undefined ? label : undefined} sx={groupListSx}>
    {children}
  </Box>
);

export const SettingsGroup: React.FC<SettingsGroupProps> = ({
  title,
  headingLevel = 'h2',
  description,
  count,
  footer,
  'aria-label': ariaLabel,
  children,
}) => {
  const headingId = useId();
  const hasFooter = footer !== undefined && footer !== null && footer !== false;

  if (title === undefined) {
    return (
      <Box sx={untitledRootSx}>
        <GroupList label={ariaLabel}>{children}</GroupList>
        {hasFooter && <Box>{footer}</Box>}
      </Box>
    );
  }
  return (
    <Box sx={groupRootSx}>
      <SectionHeading id={headingId} label={title} headingLevel={headingLevel} description={description} count={count}>
        <GroupList labelledBy={headingId}>{children}</GroupList>
        {hasFooter && <Box>{footer}</Box>}
      </SectionHeading>
    </Box>
  );
};
